import React, { useEffect, useState } from "react";
import Main from "../../common/Main/Main";
import KnowledgeByMeService from "../../services/KnowledgeByMeService";
import Loadspinner from "../../common/Loadspinner";
import PropTypes from "prop-types";
import DataCards2 from "../../common/DataCards2/DataCards2";
import { APICall } from "../../helpers/API/APICalls";
import { getKnowledgeCreatedByMe } from "../../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

function KnowledgeByMe(props) {
  const [isLoading, setLoading] = useState(false);
  const [knowledgebyMe, setKnowledgebyMe] = useState([]);
  const [ismore, setMore] = useState(true);

  useEffect(() => {
    //getKnowledgebyMe(1);
    getKnowledgebyMeNew(1);
  }, []);

  const getKnowledgebyMe = async (page) => {
    let scrollPosition = getFromEncLocalStorage("position");
    setLoading(true);
    let reqBody = {
      limit: 10,
      pageNo: page,
    };
    const res = await KnowledgeByMeService.KnowledgeByMe(reqBody);
    if (res) {
      if (res.length < 10) {
        setMore(false);
      }
      let data = [...knowledgebyMe, ...res];
      setKnowledgebyMe(data);
    }
    if (props.location.state != undefined) {
      window.scrollTo(0, scrollPosition);
    }
    setLoading(false);
  };

  const getKnowledgebyMeNew = async (start) => {
    setLoading(true);
    const employeeNum = getFromEncLocalStorage("employeenumber");
    const reqBody = {
      "start": (start - 1) * 10,
      "resultsPerPage": 10,
      "searchText": "",
      "sortColumn": "",
      "sortDirection": "",
      "userId": employeeNum
    }
    const resp = await APICall(getKnowledgeCreatedByMe, reqBody)

    if (resp && resp?.message == "Ok") {
      //console.log(JSON.stringify(resp));
      if (resp?.data?.length < 10) {
        setMore(false);
      }
      let newData = [...knowledgebyMe, ...resp?.data];
      setKnowledgebyMe(newData);
    }
    setLoading(false);
  }

  const rerender = (val) => {
    //getKnowledgebyMe(val);
    getKnowledgebyMeNew(val);
  };

  return (
    <Main active={"knowledge_by_me"}>
      <Loadspinner filename="KnowledgeByMe.js" isLoading={isLoading} isMiddle="true" />
      <DataCards2
        dataList={knowledgebyMe}
        rerenderParentCallback={rerender}
        ismore={ismore}
      />
    </Main>
  );
}

export default KnowledgeByMe;

KnowledgeByMe.propTypes = {
  location: PropTypes.object,
};
